import { render, staticRenderFns } from "./specifiedGroups.vue?vue&type=template&id=835bcec6&scoped=true"
import script from "./specifiedGroups.vue?vue&type=script&lang=js"
export * from "./specifiedGroups.vue?vue&type=script&lang=js"
import style0 from "./specifiedGroups.vue?vue&type=style&index=0&id=835bcec6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "835bcec6",
  null
  
)

export default component.exports